import * as React from "react";
import { useTranslation } from "react-i18next";
import { routes } from "../../appRoutingHelpers";
import Spinner from "../common/Spinner";
import { PageHeader } from "../common/PageHeader";
import moment from "moment";
import BeaconViewFiltersForm from "./BeaconViewFiltersForm";
import { useParams } from "react-router-dom";
import * as authSelectors from "../auth/authSelectors";
import { useGetBeaconCharges } from "../../service/api";
import { useSelector } from "react-redux";
import { useHandleFetchError } from "../../error-handler";

export const BeaconView = () => {
  const { id, idNfc } = useParams<{
    id: string | undefined;
    idNfc: string | undefined;
  }>();

  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  const [filters, setFilters] = React.useState({
    filterByLastActivityFrom: "",
  });
  const { t } = useTranslation();

  const onSearch = (values: any) => {
    setFilters(values);
  };
  const onReset = () => {
    setFilters({ filterByLastActivityFrom: "" });
  };

  const {
    data: beaconCharges,
    isLoading: isLoadingBeaconCharges,
    error,
  } = useGetBeaconCharges(organizationKeyName, idNfc, filters, id);

  useHandleFetchError(error);

  return (
    <div className="container">
      <PageHeader
        title="Beacon Charges"
        breadcrumbs={[
          { title: "Beacons" },
          {
            title: "Overview",
            link: routes.beaconStatus(organizationKeyName),
          },
          { title: "Charges", isActive: true },
        ]}
      />

      <div className="row row-cards row-deck">
        <div className="col-12">
          <BeaconViewFiltersForm onSubmit={onSearch} onReset={onReset} />
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Beacon Charge Logs</h3>
            </div>
            {beaconCharges && (
              <div className="table-responsive">
                <table className="table table-hover table-outline table-vcenter card-table">
                  <thead>
                    <tr>
                      <th>Crated At</th>
                      <th>Charge Id</th>
                      <th>Member Card Id</th>
                      <th>Pos Terminal Token</th>
                      <th>Pos Venue Ref (Id)</th>
                      <th>Pos Waiter Name (number)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {beaconCharges.map((x) => (
                      <tr key={x.id}>
                        <td>
                          {`${t("beacon.charge_list.row.date", {
                            date: moment(x.createdAt),
                          })}`}
                        </td>
                        <td>{x.chargeId}</td>
                        <td>{x.memberCardId}</td>
                        <td>{x.posTerminalToken}</td>
                        <td>
                          {x.posVenueRef} ({x.posVenueId})
                        </td>
                        <td>
                          {x.posWaiterName} ({x.posWaiterNumber})
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {isLoadingBeaconCharges && (
              <div className="text-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
